import cn from "classnames";
import Heading from "../../components/heading/Heading";
import StaffCard from "./components/staffCard/StaffCard";
import React, { FC } from "react";
import st from './staff.module.scss';
import { staff } from "@pages/partners/items/uralchem/static/sectionsData";

interface StaffProps {
    className: string
}
const Staff: FC<StaffProps> = ({className}) => {
    return (
        <section className={cn(className, st['staff'])}>
            <Heading.Section>Персонал</Heading.Section>
            <div className={st['staff__list']}>
                {staff.map(({icon, text}) => <StaffCard icon={icon} text={text}/>)}
            </div>
        </section>
    );
};

export default Staff;